<usb-trip-header
  *ngIf="itinerary"
  [title]="'FILE N° ' + (itinerary?.id || '')"
  [destinySecuency]="destinySecuency"
  [arrivalDateFull]="userService?.itineraryArrivalDateFull"
  [departureDateFull]="userService?.itineraryDepartureDateFull"
  [timeArrive]="timeArrive"
  [timeDropoff]="timeDropoff"
  [qtyDays]="qtyDays"
  [qtyNights]="qtyNights"
  [adults]="adults"
  [children]="children"
  [hasHotel]="existHotel()"
  [itinerary]="itinerary"
  [payloadSearchTransportFly]="payloadSearchTransportFly"
  [formTransportsFly]="formTransportsFly"
  [clientSetting]="getClientsSettingAppBooking"
>
</usb-trip-header>